import { Action, IGroup, Util } from '@antv/g2';
import { get } from '@antv/util';
import { BBox, ButtonCfg } from '../../types';
import { deepAssign, normalPadding } from '../../utils';

const PADDING_RIGHT = 10;
const PADDING_TOP = 5;

/**
 * Action ä¸­ç Button æé®éç½®
 *
 * å¯è½çä½¿ç¨åºæ¯ï¼brush filter
 */
export const BUTTON_ACTION_CONFIG: ButtonCfg = {
  padding: [8, 10],
  text: 'reset',
  textStyle: {
    default: {
      x: 0,
      y: 0,
      fontSize: 12,
      fill: '#333333',
      cursor: 'pointer',
    },
  },
  buttonStyle: {
    default: {
      fill: '#f7f7f7',
      stroke: '#cccccc',
      cursor: 'pointer',
    },
    active: {
      fill: '#e6e6e6',
    },
  },
};

/**
 * @override å¤å G2 Button Action, åç»­ç´æ¥ä½¿ç¨ GUI
 */
class ButtonAction extends Action {
  private buttonGroup: IGroup = null;
  private buttonCfg = {
    name: 'button',
    ...BUTTON_ACTION_CONFIG,
  };

  /**
   * è·å mix é»è®¤çéç½®åç¨æ·éç½®
   */
  private getButtonCfg(): ButtonCfg & { name: string } {
    const { view } = this.context;
    const buttonCfg: ButtonCfg = get(view, ['interactions', 'filter-action', 'cfg', 'buttonConfig']);

    return deepAssign(this.buttonCfg, buttonCfg, this.cfg);
  }

  /**
   * ç»å¶ Button å ææ¬
   */
  private drawButton() {
    const config = this.getButtonCfg();
    const group = this.context.view.foregroundGroup.addGroup({
      name: config.name,
    });
    const textShape = this.drawText(group);
    this.drawBackground(group, textShape.getBBox());

    this.buttonGroup = group;
  }

  /**
   * ç»å¶ææ¬
   */
  private drawText(group: IGroup) {
    const config = this.getButtonCfg();
    // æ·»å ææ¬
    return group.addShape({
      type: 'text',
      name: 'button-text',
      attrs: {
        text: config.text,
        ...config.textStyle?.default,
      },
    });
  }

  private drawBackground(group: IGroup, bbox: BBox) {
    const config = this.getButtonCfg();
    const padding = normalPadding(config.padding);
    // æ·»å èæ¯æé®
    const buttonShape = group.addShape({
      type: 'rect',
      name: 'button-rect',
      attrs: {
        x: bbox.x - padding[3],
        y: bbox.y - padding[0],
        width: bbox.width + padding[1] + padding[3],
        height: bbox.height + padding[0] + padding[2],
        ...config.buttonStyle?.default,
      },
    });
    buttonShape.toBack(); // å¨åé¢

    // active ææåç½®
    group.on('mouseenter', () => {
      buttonShape.attr(config.buttonStyle?.active);
    });
    group.on('mouseleave', () => {
      buttonShape.attr(config.buttonStyle?.default);
    });

    return buttonShape;
  }

  // éç½®ä½ç½®
  private resetPosition() {
    const view = this.context.view;
    const coord = view.getCoordinate();
    const point = coord.convert({ x: 1, y: 1 }); // åé¢ç´æ¥æ¹æå·¦ä¸è§
    const buttonGroup = this.buttonGroup;
    const bbox = buttonGroup.getBBox();
    const matrix = Util.transform(null, [
      ['t', point.x - bbox.width - PADDING_RIGHT, point.y + bbox.height + PADDING_TOP],
    ]);
    buttonGroup.setMatrix(matrix);
  }

  /**
   * æ¾ç¤º
   */
  public show() {
    if (!this.buttonGroup) {
      this.drawButton();
    }
    this.resetPosition();
    this.buttonGroup.show();
  }

  /**
   * éè
   */
  public hide() {
    if (this.buttonGroup) {
      this.buttonGroup.hide();
    }
  }

  /**
   * éæ¯
   */
  public destroy() {
    const buttonGroup = this.buttonGroup;
    if (buttonGroup) {
      buttonGroup.remove();
    }
    super.destroy();
  }
}

export { ButtonAction };
